var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"togglable-section"},[_c('header-with-toggle',{attrs:{"title":_vm.title,"expanded":_vm.expanded},on:{"toggle":function($event){_vm.expanded = !_vm.expanded}}}),_vm._v(" "),(_vm.expanded)?_c('ul',{staticClass:"list-group"},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c1569e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/togglable-section.vue
// module id = vgNS
// module chunks = 0